
// OJ 
export const BASE_API = "https://45811.acmcoder.com"


// C 
export const REPORT_API = "https://report1014.acmcoder.com"

export const LOGIN_API = "https://62885.acmcoder.com"


// WEBPACK FOOTER //
// ./src/api.js